const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  buttonBase: {
    display: 'block',
    marginBottom: 16,
    paddingBottom: 8
  },
  passed: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.success
  },
  failed: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.error.main
  },
  button: {
    margin: theme.spacing.unit,
    background: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },

  textFieldRoot: {
    margin: theme.spacing.unit,
    '&:focus': {
      outline: 'none'
    }
  },
  bar: {
    marginTop: '20px',
  },
  textFieldInput: {
    background: theme.palette.primary.contrastText,
    borderRadius: '25px',
    padding: '10px 15px',
    color: theme.palette.primary.light,
  },
  aggregatedInfo: {
    padding: '10px',
    background: '#000000',
    color: '#FFFFFF'
  },
  aggregatedInfoHidden: {
    height: '0px'
  },
  groupedInfo: {
    maxWidth: 'initial !important',
    width: '100% !important',
    padding: '0px !important'
  },
  groupedInfoHidden: {
    display: 'none !important',
    padding: '0px !important'
  },
  aggregatedHidden: {
    flex: '1 !important',
    padding: '0px !important',
    maxWidth: '0px',
    borderRight: '0px !important'
  },
  suspiciousfilter: {
    margin: 0,
    color: 'white',
    height: '100%',
    width: '100%',
    fontSize: '0.8rem',
    fontWeight: 400,
    letterSpacing: '0.5px'
  },
  suspiciousfilternotrun: {
    backgroundColor: 'rgba(0, 0, 0, 0.12)!important',
  },
  suspiciousfilteractivated: {
    backgroundColor: theme.palette.primary.main,
  },
  attachment: {
    padding: 0,
    minWidth: 'initial',
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  failStateBadge: {
    color: theme.palette.fail,
  },
  passStateBadge: {
    color: theme.palette.success,
  },
  divContent: {
    height: "100%",
  },
  failFlag: {
    color: theme.palette.fail,
    cursor: 'pointer'
  }
})

export default styles
